import { createSelector } from '@reduxjs/toolkit';
import { LoadingProgress } from '../types';
import { Selector } from './../types/redux';
import { hasErrorsSelectorFactory, isLoadingSelectorFactory } from '.';

export const progressSelectorFactory = (actionTypes: string[]): Selector<LoadingProgress> => {
  return createSelector(isLoadingSelectorFactory(actionTypes), hasErrorsSelectorFactory(actionTypes), (isLoading, hasErrors) => {
    const ret: LoadingProgress = { isLoading, hasErrors };
    return ret;
  });
};
